import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS types
import { RootState } from '@redux/store';
import { ISessionBlockProps } from '@redux/common'; //TODO:空定義

// import module
import IcRcln from '@magaele/ic_rcln';

// shared components
import Session from '@component/Common/session';

// redux actions
import { setSessionErrorMsg, setPickSession } from '@redux/Normal/actions';

// common function

// plugin
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const SessionBlock = React.forwardRef<HTMLDivElement, ISessionBlockProps>((props, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { allSessions, pickSession, disabledSessions, sessionErrorMsg } = useSelector(
        (state: RootState) => state.Normal
    );

    //點選場次
    const sessionClickHandler = (session: string) => {
        if (disabledSessions.includes(session)) {
            return;
        }
        if (pickSession === session) {
            dispatch(setPickSession(''));
        } else {
            dispatch(setSessionErrorMsg(''));
            dispatch(setPickSession(session));
        }
    };

    let optionData = [];
    if (allSessions && allSessions.length !== 0) {
        allSessions.forEach((session) => {
            if (disabledSessions.includes(session)) {
                optionData.push({ text: session, value: session, disabled: true });
            } else {
                optionData.push({ text: session, value: session });
            }
        });
        optionData.unshift({ text: t('noTHSR.session.choose', {particle: 'THSR.commonPanel.please'}), value: '' });
    }
    
    const sessionProps = {
        option: optionData,
        sessionPicked: pickSession || '',
        disabledSessions: disabledSessions,
        itemClick: (idx: number) => {
            // console.log('sessionitemClickvalue', idx);
            sessionClickHandler(optionData[idx].value);
        },
        onChangeCallBack: (value: string) => {
            // console.log('dropdownSelectedvalue', value);
            dispatch(setSessionErrorMsg(''));
            dispatch(setPickSession(value));
        },
        icon: [<IcRcln name="clock" className="svg" />],
        isGDS: false
    };
    return (
        <div className="sessionBlock" ref={ref}>
            <div className="sessionTitle">
                <div className="subTitle">{t('noTHSR.session.sessionAndTime')}</div>
                <div className={cx('errorMsg', { showError: !!sessionErrorMsg })}>
                    {sessionErrorMsg}
                </div>
            </div>
            <Session {...sessionProps} />
        </div>
    );
});

export default SessionBlock;
